import React, { Component } from 'react';
import SubDeptartmentForm from '../companents/SubDeptartmentForm/index';
import { getCurrentBreadCrumbs } from '@/utils/utils';
import Container from '../../../../../components/Container';
import styles from './index.less';

class Department extends Component {
  render() {
    // 面包屑
    const breadcrumb = getCurrentBreadCrumbs({
      currentUrl: {
        context: '部门管理',
        path: `/countyContacts/department${window.location.search}`,
      },
      isTop: true,
      storekey: 'countyManagementCenterBreadcrumb',
    });

    return (
      <Container breStates isBreVersion defaultPadding breDataSource={breadcrumb}>
        <div className={styles['primary-sector']}>
          <div className="content-container">
            <SubDeptartmentForm type={1} />
          </div>
        </div>
      </Container>
    );
  }
}

export default Department;
